// filepath: /components/shipments-products/ExpandedShipmentProducts.tsx
import React from "react";
import { ShipmentProduct, ProductComponent, StpDetails } from "../../graphql/graphql";
import { ShipmentProductsTable } from "../shipment-products-table/ShipmentProductsTable";
import type { TableRef } from "../base-table";
import type { PaginationState } from "@tanstack/react-table";

type Props = {
  loading: boolean;
  error: string | null;
  products: ShipmentProduct[];
  shipmentProductsTableRef: React.RefObject<TableRef>;
  handleHtsCodeView: (args: { components: ProductComponent[] }) => void;
  handleShowInvoicesOrdersView: (args: { product: ShipmentProduct | null }) => void;
  handleStpDetailsView: (args: { stpDetails: StpDetails[] | [] }) => void;
  pageIndex: number;
  pageSize: number;
  totalCount: number;
  onPaginationChange: (pagination: PaginationState) => void;
};

export const ExpandedShipmentProducts: React.FC<Props> = ({
  loading,
  error,
  products,
  shipmentProductsTableRef,
  handleHtsCodeView,
  handleShowInvoicesOrdersView,
  handleStpDetailsView,
  pageIndex,
  pageSize,
  totalCount,
  onPaginationChange,
}) => (
  <>
    {error && <div>Error loading shipment products: {error}</div>}
    <ShipmentProductsTable
      tableRef={shipmentProductsTableRef}
      data={products}
      handleHtsCodeView={handleHtsCodeView}
      handleShowInvoicesOrdersView={handleShowInvoicesOrdersView}
      handleStpDetailsView={handleStpDetailsView}
      isLoading={loading}
      error={error}
      state={{
        sorting: [],
        columnFilters: [],
        setSorting: () => {},
        setColumnFilters: () => {},
        columnOrder: [],
        setColumnOrder: () => {},
        setRowSelection: () => {},
        rowSelection: {},
        resetRowSelection: () => {},
        columnVisibility: {},
        pagination: { totalCount },
        globalSearch: "",
        expanded: {},
        columnFiltersSidePanelIsOpen: false,
      }}
      enableGlobalFilter={false}
      enableRowSelection={false}
      meta={{}}
      pageIndex={pageIndex}
      pageSize={pageSize}
      totalCount={totalCount}
      onPaginationChange={onPaginationChange}
      enablePagination={true}
    />
  </>
);